import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { isDarkPreferred } from './theme';

Vue.use(Vuetify);

// The brand accent (sky) is the same family in both themes — only its lightness
// changes, so it keeps contrast against near-black surfaces. Everything else is
// the neutral charcoal ramp: no blue tint anywhere in the chrome.
const light = {
  primary: '#0ea5e9',
  secondary: '#64748b',
  accent: '#0284c7',
  info: '#0ea5e9',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  anchor: '#0ea5e9',
};

const dark = {
  primary: '#38bdf8',
  secondary: '#a3a3a3',
  accent: '#0ea5e9',
  info: '#38bdf8',
  success: '#34d399',
  warning: '#fbbf24',
  error: '#f87171',
  anchor: '#38bdf8',
};

export default new Vuetify({
  theme: {
    // The stored preference is read here rather than after mount, so the very
    // first render is already in the right theme. bootstrap() in main.js waits
    // on an API call before mounting, which would otherwise mean a long flash.
    dark: isDarkPreferred(),
    themes: { light, dark },
    // Emits --v-primary-base &c so hand-written CSS can read theme colours.
    options: { customProperties: true },
  },
});
